module.exports = __webpack_public_path__ + "static/media/ardentarola2.8040d35f.png";